export function fmtCLP(n: number): string {
  return "$" + new Intl.NumberFormat("es-CL").format(Math.round(n || 0));
}

export function fmtInt(n: number): string {
  return new Intl.NumberFormat("es-CL").format(Math.round(n || 0));
}

export function fmtCLPCompact(n: number): string {
  const v = Math.round(n || 0);
  if (Math.abs(v) >= 1_000_000) return "$" + (v / 1_000_000).toFixed(1) + "M";
  if (Math.abs(v) >= 1_000) return "$" + (v / 1_000).toFixed(0) + "k";
  return "$" + v;
}

export function fmtDayShort(isoDay: string): string {
  try {
    const dt = new Date(isoDay + "T00:00:00");
    return dt.toLocaleDateString("es-CL", { day: "2-digit", month: "short" });
  } catch {
    return isoDay;
  }
}

export function fmtHourShort(iso: string): string {
  try {
    return new Date(iso).toLocaleTimeString("es-CL", {
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return "—";
  }
}
